import React, { useEffect, useRef } from "react";
import { Box, Typography, Stack, Paper } from "@mui/material";
import MessageContainer from "./Message";
import MessageInputContainer from "./MessageInputContainer";

// MessagesContainer Component
const MessagesContainer = ({
  messages,
  expandedMessages,
  onExpand,
  newMessage,
  setNewMessage,
  onSendMessage,
  isAddingMessage,
  currentUser = null,
  onEditMessage,
  onDeleteMessage,
  editingMessageId,
  deletingMessageId,
}) => {
  const messagesEndRef = useRef(null);

  // Sort messages chronologically (oldest first, newest at bottom)
  const sortedMessages = [...messages].sort((a, b) => {
    const dateA = new Date(a.createdOn);
    const dateB = new Date(b.createdOn);
    return dateA - dateB; // Always oldest first
  });

  // Auto-scroll to bottom when messages change
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    scrollToBottom();
  }, []);

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      {/* <Box sx={{ p: 2, borderBottom: "1px solid #e5e7eb" }}>
        <Typography variant="subtitle1" fontWeight={600}>
          Messages ({messages.length})
        </Typography>
      </Box> */}

      {/* Messages List */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          pr: 1,
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "3px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#c1c1c1",
            borderRadius: "3px",
            "&:hover": {
              background: "#a8a8a8",
            },
          },
        }}
      >
        {sortedMessages.length === 0 ? (
          <Paper sx={{ p: 3, textAlign: "center", m: 2 }}>
            <Typography color="text.secondary">
              No messages found for this complaint.
            </Typography>
          </Paper>
        ) : (
          <Stack spacing={1} sx={{ pb: 1 }}>
            {sortedMessages.map((msg, idx) => (
              <MessageContainer
                key={msg._id || idx}
                msg={msg}
                idx={idx}
                isExpanded={expandedMessages.has(idx)}
                onExpand={onExpand}
                currentUser={currentUser}
                onEdit={onEditMessage}
                onDelete={onDeleteMessage}
                isEditing={editingMessageId}
                isDeleting={deletingMessageId}
              />
            ))}
            {/* Invisible element to scroll to */}
            <div ref={messagesEndRef} />
          </Stack>
        )}
      </Box>

      {/* Message Input */}
      <Box sx={{ borderTop: "1px solid #e5e7eb" }}>
        <MessageInputContainer
          newMessage={newMessage}
          setNewMessage={setNewMessage}
          onSendMessage={onSendMessage}
          isAddingMessage={isAddingMessage}
        />
      </Box>
    </Box>
  );
};

export default MessagesContainer;
